import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume7 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload}/>
      <div className="w-full mx-auto my-5 bg-white shadow-lg p-6" ref={resumeRef}>
        <header className="text-center mb-5">
          <h1 className="text-3xl font-bold text-[#0046b3]">
            {ResumeStore.resumeBuilder.personalDetails.firstName} {ResumeStore.resumeBuilder.personalDetails.lastName}
          </h1>
          <p>
            {ResumeStore.resumeBuilder.personalDetails.city}, {ResumeStore.resumeBuilder.personalDetails.country} {ResumeStore.resumeBuilder.personalDetails.postalCode} | {ResumeStore.resumeBuilder.personalDetails.phone} | {ResumeStore.resumeBuilder.personalDetails.email}
          </p>
        </header>
        <section className="mb-5">
          <h2 className="text-2xl text-[#0046b3] mb-3">Professional Summary</h2>
          <p>{ResumeStore.resumeBuilder.profileSummary}</p>
        </section>
        <section className="mb-5">
          <h2 className="text-2xl text-[#0046b3] mb-3">Skills</h2>
          <div className="flex justify-between">
            <ul className="w-1/2 list-none mr-2">
              {ResumeStore.resumeBuilder.skills.slice(0, Math.ceil(ResumeStore.resumeBuilder.skills.length / 2)).map((skill, index) => (
                <li key={index} className="bg-[#f0f4f8] my-1 p-2 px-5 rounded-full flex items-center">
                  <span className="text-[#0046b3] text-3xl mr-2">•</span>{skill}
                </li>
              ))}
            </ul>
            <ul className="w-1/2 list-none ml-2">
              {ResumeStore.resumeBuilder.skills.slice(Math.ceil(ResumeStore.resumeBuilder.skills.length / 2)).map((skill, index) => (
                <li key={index} className="bg-[#f0f4f8] my-1 p-2 px-5 rounded-full flex items-center">
                  <span className="text-[#0046b3] text-3xl mr-2">•</span>{skill}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <section className="mb-5">
          <h2 className="text-2xl text-[#0046b3] mb-3">Work History</h2>
          {ResumeStore.resumeBuilder.employementHistory.map((job, index) => (
            <div key={index} className="mb-4">
              <div className="flex justify-between">
                <h3 className="text-xl font-bold">{job.jobTitle}</h3>
                <span className="text-[#0046b3] font-bold">{job.startDate} - {job.endDate}</span>
              </div>
              <p>{job.company}</p>
              <p>{job.city}</p>
              <p>{job.description}</p>
            </div>
          ))}
        </section>
        <section className="mb-5">
          <h2 className="text-2xl text-[#0046b3] mb-3">Education</h2>
          {ResumeStore.resumeBuilder.education.map((edu, index) => (
            <div key={index} className="mb-4">
              <div className="flex justify-between">
                <h3 className="text-xl font-bold">{edu.degree}</h3>
                <span className="text-[#0046b3] font-bold">{edu.startDate} - {edu.endDate}</span>
              </div>
              <p>{edu.school}</p>
              <p>{edu.city}</p>
              <p>{edu.description}</p>
            </div>
          ))}
        </section>
      </div>
    </>
  ));
}

export default Resume7;
